var SENTRY_RELEASE;SENTRY_RELEASE={name: "HiNote Life TV Staging", version: "4.0.2"};